import React from 'react';
import PropTypes from 'prop-types';
import { TicketDetailsCard } from './TicketDetailsCard';
import styles from './TicketDetailsSection.module.css';

export const TicketDetailsSection = ({ 
  tickets, 
  onAccept, 
  onIgnore 
}) => {
  if (!tickets || tickets.length === 0) {
    return (
      <div className={styles.section}>
        <div className={styles.emptyState}>
          <p>No tickets match the current filters.</p>
        </div>
      </div>
    );
  }

  // Enhanced handlers that can be easily modified for live data
  const handleAccept = (ticketId, data) => {
    // API call
    console.log('Ticket accepted:', ticketId, data);
    console.log('Status changed to:', data.newStatus); // Will log 'WORK IN PROGRESS'
    
    // Call parent handler
    if (onAccept) {
      onAccept(ticketId, data);
    }
  };

  const handleIgnore = (ticketId, data) => {
    // API call
    console.log('Ticket ignored:', ticketId, data);
    
    // Call parent handler if provided
    if (onIgnore) {
      onIgnore(ticketId, data);
    }
  };

  return (
    <div className={styles.section}>
      <div className={styles.ticketsList}>
        {tickets.map((ticket) => (
          <TicketDetailsCard
            key={ticket.id}
            id={ticket.id}
            title={ticket.title}
            description={ticket.description}

            effort={ticket.effort}
            system={ticket.system}
            statusType={ticket.statusType}
            effortType={ticket.effortType}
            onAccept={handleAccept}
            onIgnore={handleIgnore}
          />
        ))}
      </div>
    </div>
  );
};

TicketDetailsSection.propTypes = {
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,

      effort: PropTypes.string.isRequired,
      system: PropTypes.string.isRequired,
      statusType: PropTypes.string.isRequired
    })
  ).isRequired,
  onAccept: PropTypes.func,
  onIgnore: PropTypes.func
};